import { render, staticRenderFns } from "./order-custom-refund.vue?vue&type=template&id=49242912&scoped=true&"
import script from "./order-custom-refund.vue?vue&type=script&lang=js&"
export * from "./order-custom-refund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49242912",
  null
  
)

export default component.exports